module.exports = __webpack_public_path__ + "img/Scot.1f2c88b7.jpeg";